import { render, staticRenderFns } from "./SongPreviewsAndFeedback.vue?vue&type=template&id=46e5da6c&scoped=true&"
import script from "./SongPreviewsAndFeedback.vue?vue&type=script&lang=ts&"
export * from "./SongPreviewsAndFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./SongPreviewsAndFeedback.vue?vue&type=style&index=0&id=46e5da6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5da6c",
  null
  
)

export default component.exports